module.exports = __webpack_public_path__ + "img/jellybean_trax.e76dabc0.png";